import React, { useEffect, useRef } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5percent from "@amcharts/amcharts5/percent";
import * as am5radar from "@amcharts/amcharts5/radar";
import * as am5map from "@amcharts/amcharts5/map";
import am5geodata_worldLow from "@amcharts/amcharts5-geodata/worldLow";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

const WillItBend = () => {
    const chartRef = useRef(null);

    useEffect(() => {
        let root = am5.Root.new(chartRef.current);

        root.setThemes([
            am5themes_Animated.new(root)
        ]);

        // Theme colors
        const interfaceColors = am5.ColorSet.new(root, {
            colors: [
                am5.color(getComputedStyle(document.documentElement).getPropertyValue('--chart-bg').trim()), // background
                am5.color(getComputedStyle(document.documentElement).getPropertyValue('--chart-text').trim()), // text
                am5.color(getComputedStyle(document.documentElement).getPropertyValue('--chart-1').trim()), // primary fill
                am5.color(getComputedStyle(document.documentElement).getPropertyValue('--chart-2').trim()), // secondary fill
                am5.color(getComputedStyle(document.documentElement).getPropertyValue('--chart-3').trim()), // primary fill
                am5.color(getComputedStyle(document.documentElement).getPropertyValue('--chart-4').trim()), // secondary fill
                am5.color(getComputedStyle(document.documentElement).getPropertyValue('--chart-5').trim()), // primary fill
                am5.color(getComputedStyle(document.documentElement).getPropertyValue('--chart-6').trim())  // secondary fill
            ]
        });

        root.container.set("layout", root.verticalLayout);
        root.container.set("background", am5.Rectangle.new(root, {
            fill: interfaceColors.getIndex(0)
        }));

        let container = root.container.children.push(am5.Container.new(root, {
            width: am5.percent(100),
            height: am5.percent(100),
            layout: root.verticalLayout
        }));

        // Header
        let headerLabel = container.children.push(am5.Label.new(root, {
            // text: "Will it bend?",
            fontSize: 30,
            fontWeight: "bold",
            fill: interfaceColors.getIndex(1),
            textAlign: "center",
            x: am5.percent(50),
            centerX: am5.percent(50),
            paddingTop: 30,
            paddingBottom: 30
        }));

        let currentChart = null;
        let timeoutIds = [];

        function clearScene() {
            if (currentChart) {
                currentChart.dispose();
                currentChart = null;
            }
            timeoutIds.forEach(id => clearTimeout(id));
            timeoutIds = [];
        }

        // Data for charts
        const chartData = [
            { category: "All", value: 10 },
            { category: "figures", value: 20 },
            { category: "you", value: 30 },
            { category: "can", value: 40 },
            { category: "dynamically", value: 50 },
            { category: "display", value: 60 }
        ];

        // SCENE 1: Map
        function showMapScene() {
            clearScene();
            // headerLabel.set("text", "Flying to destination...");

            let chart = container.children.push(am5map.MapChart.new(root, {
                panX: "rotateX",
                panY: "none",
                projection: am5map.geoMercator(),
                homeGeoPoint: { longitude: 10, latitude: 50 },
                homeZoomLevel: 1
            }));
            currentChart = chart;

            let polygonSeries = chart.series.push(am5map.MapPolygonSeries.new(root, {
                geoJSON: am5geodata_worldLow,
                exclude: ["AQ"]
            }));

            polygonSeries.mapPolygons.template.setAll({
                fill: interfaceColors.getIndex(2),
                stroke: interfaceColors.getIndex(3),
                strokeWidth: 0.5
            });

            // Plane animation (simplified from demo.jsx)
            let pointSeries = chart.series.push(am5map.MapPointSeries.new(root, {}));
            let planePath = "M71,515.3l-33,72.5c-0.9,2.1,0.6,4.4,2.9,4.4l19.7,0c2.8,0,5.4-1,7.5-2.9l54.1-39.9c2.4-2.2,5.4-3.4,8.6-3.4 l103.9,0c1.8,0,3,1.8,2.3,3.5l-64.5,153.7c-0.7,1.6,0.5,3.3,2.2,3.3l40.5,0c2.9,0,5.7-1.3,7.5-3.6L338.4,554c3.9-5,9.9-8,16.2-8c24.2,0,85.5-0.1,109.1-0.2c21.4-0.1,41-6.3,59-17.8c4.2-2.6,7.9-6.1,11.2-9.8c2.6-2.9,3.8-5.7,3.7-8.5c0.1-2.8-1.1-5.5-3.7-8.5c-3.3-3.7-7-7.2-11.2-9.8c-18-11.5-37.6-17.7-59-17.8c-23.6-0.1-84.9-0.2-109.1-0.2c-6.4,0-12.3-2.9-16.2-8L222.6,316.6c-1.8-2.3-4.5-3.6-7.5-3.6l-40.5,0c-1.7,0-2.9,1.7-2.2,3.3L237,470c0.7,1.7-0.5,3.5-2.3,3.5l-103.9,0c-3.2,0-6.2-1.2-8.6-3.4l-54.1-39.9c-2.1-1.9-4.7-2.9-7.5-2.9l-19.7,0c-2.3,0-3.8,2.4-2.9,4.4l33,72.5C72.6,507.7,72.6,511.8,71,515.3z";

            let plane = pointSeries.bullets.push(function () {
                return am5.Bullet.new(root, {
                    sprite: am5.Graphics.new(root, {
                        svgPath: planePath,
                        fill: am5.color(0xffcc00),
                        scale: 0.05,
                        centerY: am5.p50,
                        centerX: am5.p50,
                    })
                });
            });

            let paris = { longitude: 2.3522, latitude: 48.8566 };
            let ny = { longitude: -74.0060, latitude: 40.7128 };

            let lineSeries = chart.series.push(am5map.MapLineSeries.new(root, {}));
            let lineDataItem = lineSeries.pushDataItem({
                geometry: {
                    type: "LineString",
                    coordinates: [[paris.longitude, paris.latitude], [ny.longitude, ny.latitude]]
                }
            });

            let planeDataItem = pointSeries.pushDataItem({
                lineDataItem: lineDataItem,
                positionOnLine: 0,
                autoRotate: true
            });

            timeoutIds.push(setTimeout(() => {
                planeDataItem.animate({
                    key: "positionOnLine",
                    to: 1,
                    duration: 3000,
                    easing: am5.ease.inOut(am5.ease.cubic)
                });
                chart.animate({
                    key: "rotationX",
                    to: -ny.longitude,
                    duration: 3000,
                    easing: am5.ease.inOut(am5.ease.cubic)
                });
            }, 500));

            timeoutIds.push(setTimeout(showRadarScene, 4000));
        }

        // SCENE 2: Radar
        function showRadarScene() {
            clearScene();
            // headerLabel.set("text", "Yes, it bends!");

            let chart = container.children.push(am5radar.RadarChart.new(root, {
                panX: false,
                panY: false,
                startAngle: -90,
                endAngle: 270,
                innerRadius: am5.percent(40)
            }));
            currentChart = chart;

            let xRenderer = am5radar.AxisRendererCircular.new(root, {});
            xRenderer.labels.template.setAll({ textType: "radial", radius: 10, fill: interfaceColors.getIndex(1) });

            let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
                maxDeviation: 0,
                categoryField: "category",
                renderer: xRenderer
            }));

            let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
                renderer: am5radar.AxisRendererRadial.new(root, {}),
                min: 0
            }));

            let series = chart.series.push(am5radar.RadarColumnSeries.new(root, {
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: "value",
                categoryXField: "category",
                sequencedInterpolation: true
            }));

            series.columns.template.setAll({ cornerRadius: 5 });
            series.columns.template.adapters.add("fill", (fill, target) => interfaceColors.getIndex(series.columns.indexOf(target) + 1));

            xAxis.data.setAll(chartData);
            series.data.setAll(chartData);

            series.appear(1000);
            chart.appear(1000, 100);

            // Bend animation
            chart.animate({
                key: "startAngle",
                from: -90,
                to: 0,
                duration: 2000,
                easing: am5.ease.inOut(am5.ease.sine),
                yoyo: true,
                loops: 2
            });
            chart.animate({
                key: "endAngle",
                from: 270,
                to: 180,
                duration: 2000,
                easing: am5.ease.inOut(am5.ease.sine),
                yoyo: true,
                loops: 2
            });

            timeoutIds.push(setTimeout(showXYScene, 5000));
        }

        // SCENE 3: XY (Bar)
        function showXYScene() {
            clearScene();
            // headerLabel.set("text", "Unbending to Bar Chart...");

            let chart = container.children.push(am5xy.XYChart.new(root, {
                panX: false,
                panY: false,
                layout: root.verticalLayout
            }));
            currentChart = chart;

            let xRenderer = am5xy.AxisRendererX.new(root, { minGridDistance: 30 });
            xRenderer.labels.template.setAll({ fill: interfaceColors.getIndex(1) });

            let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
                categoryField: "category",
                renderer: xRenderer,
                tooltip: am5.Tooltip.new(root, {})
            }));

            let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
                renderer: am5xy.AxisRendererY.new(root, {}),
                min: 0
            }));

            let series = chart.series.push(am5xy.ColumnSeries.new(root, {
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: "value",
                categoryXField: "category",
                sequencedInterpolation: true
            }));

            series.columns.template.setAll({ cornerRadiusTL: 5, cornerRadiusTR: 5 });
            series.columns.template.adapters.add("fill", (fill, target) => interfaceColors.getIndex(series.columns.indexOf(target) + 1));

            xAxis.data.setAll(chartData);
            series.data.setAll(chartData);

            series.appear(1000);
            chart.appear(1000, 100);

            timeoutIds.push(setTimeout(showPieScene, 4000));
        }

        // SCENE 4: Pie
        function showPieScene() {
            clearScene();
            // headerLabel.set("text", "Morphing to Pie Chart...");

            let chart = container.children.push(am5percent.PieChart.new(root, {
                layout: root.verticalLayout,
                innerRadius: am5.percent(40)
            }));
            currentChart = chart;

            let series = chart.series.push(am5percent.PieSeries.new(root, {
                valueField: "value",
                categoryField: "category",
                alignLabels: false
            }));

            series.labels.template.setAll({
                textType: "circular",
                radius: 10,
                fill: interfaceColors.getIndex(1)
            });

            series.slices.template.adapters.add("fill", (fill, target) => interfaceColors.getIndex(series.slices.indexOf(target) + 2));

            series.data.setAll(chartData);

            series.appear(1000, 100);
            chart.appear(1000, 100);

            timeoutIds.push(setTimeout(showMapScene, 4000));
        }

        showMapScene();

        return () => {
            root.dispose();
            timeoutIds.forEach(id => clearTimeout(id));
        };
    }, []);

    return (
        <div ref={chartRef} style={{ width: "100%", height: "80vh" }}></div>
    );
};

export default WillItBend;
